import _ from 'lodash';
import { ItemManager } from 'spark-core-dx/managers'

class ReportManager extends ItemManager {
    constructor(coreContext, coreState, isWarning) {
        super("Report", coreContext, coreState, isWarning);
    }

    async getPBIToken(reportId){
        return this._itemService.getCustom(reportId, "pbiToken").then((r) => {
            return r?.first();
        });
    }

    async issueViewerHandoff(reportId) {
        return this._itemService.postOperation({
            operationType: "viewerHandoff",
            id: reportId,
            item: {},
            isItem: false,
            isWarning: true,
            supressAllErrors: false,
        }).then((r) => {
            return r?.first();
        });
    }
}

export default ReportManager;
